var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7969 13.2129L11.5109 11.4709L13.2029 10.7869L12.4889 12.5289L10.7969 13.2129ZM15.6829 8.3179C15.4089 8.0279 14.9789 7.9159 14.5839 8.0719L10.3709 9.7739C10.1209 9.8749 9.9219 10.0719 9.8199 10.3219L8.0749 14.5799C7.9269 14.9409 8.0139 15.3309 8.2529 15.6079C8.2609 15.6179 8.2669 15.6309 8.2759 15.6419C8.2919 15.6589 8.3109 15.6729 8.3289 15.6899C8.5169 15.8829 8.7719 15.9999 9.0419 15.9999C9.1669 15.9999 9.2939 15.9769 9.4159 15.9279L13.6289 14.2269C13.8789 14.1249 14.0779 13.9279 14.1799 13.6779L15.9249 9.4199C16.0869 9.0259 15.9749 8.5939 15.6829 8.3179ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/Compass.48196634ee9b2acf031df9273878bae2.svg";
export { ForwardRef as ReactComponent };